"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.azureRoleEnvironmentTelemetryProcessor = azureRoleEnvironmentTelemetryProcessor;
/**
 *  @deprecated The method should not be called, Azure Properties will be added always when available
 *  A telemetry processor that handles Azure specific variables.
 */
function azureRoleEnvironmentTelemetryProcessor(envelope, context) {
    // NO-OP
}
//# sourceMappingURL=AzureRoleEnvironmentTelemetryInitializer.js.map